import { recent } from '@/common/service/ApiList';
import { assist } from '@/common/utils/ParameterAssistant';

import ServiceExec from '@/common/utils/ServiceExec';
import { cloneDeep } from 'lodash';

const { getList } = recent;

const actions = {
  FETCH_LIST: async ({ commit, state }, page) => {
    const { condition } = state;
    commit('setCondition', assist(condition, page));

    const { status, data } = await ServiceExec.get(getList, condition);
    if (status === 200) {
      const { list, pageInfo } = data;
      commit('setList', list ?? []);
      commit('setPageInfo', pageInfo ?? {});
    }
  },
  FETCH_FOR_XLSX: async ({ state }) => {
    const { condition } = state;
    const _condition = cloneDeep(condition);
    _condition.limit = -1;
    _condition.page = 1;

    const { status, data } = await ServiceExec.get(getList, _condition);
    if (status !== 200) return [];
    const { list, pageInfo } = data;
    return list;
  }
};
export default actions;
